import { injectionKey } from './injectionKey.js';
/**
 * Plugin for the Ioc container.
 */
export function IocPlugin(app, options) {
    app.provide(injectionKey, options.container);
}
//# sourceMappingURL=IocPlugin.js.map